import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../api.service';
import { Course } from '../course.model';
import { CourseSession } from '../course-session.model';

@Component({
    selector: 'app-landing-page-course-sessions',
    templateUrl: './landing-page-course-sessions.component.html',
    styleUrls: ['./landing-page-course-sessions.component.scss']
})
export class LandingPageCourseSessionsComponent implements OnInit {
    @Input() course: Course;

    sessions: CourseSession[] = [];
    total: number;
    isLoaded:boolean = false;
    loadingError:boolean = false;
    errorMsg:string = '';
    loadingMsg:string = '';

    constructor(
        private apiService: ApiService
    ) { }
    
    ngOnInit() {
        this.getSessions();
    }

    getSessions(): void {
        this.apiService.getCourseSessions(this.course).subscribe(
            data => {
                this.sessions = data.map(session => new CourseSession(session));
                this.isLoaded = true
            },
            error => {
                this.sessions = []
                this.loadingMsg = "An error occurred, and we were unable to load Sessions for this Course."
                this.isLoaded = true
            }
        )
    }

}
